/* import kitchen from "../../../Assets/Images/questions/questionFour/kitchen.svg";
import utility from "../../../Assets/Images/questions/questionFour/utility.svg";
import cupboard from "../../../Assets/Images/questions/questionFour/cupboard.svg";
import garage from "../../../Assets/Images/questions/questionFour/garage.svg";
import loft from "../../../Assets/Images/questions/questionFour/loft.svg";
import other from "../../../Assets/Images/questions/questionFour/other.svg"; */

export const boilerPositionData = [
  {
    title: "Kitchen",
    image:
      "https://res.cloudinary.com/duwmjod0j/image/upload/v1642170500/AquaHeat/Quote%20Icons/question%204/kitchen_bsdbo1.svg",
  },
  {
    title: "Utility Room",
    image:
      "https://res.cloudinary.com/duwmjod0j/image/upload/v1642170500/AquaHeat/Quote%20Icons/question%204/utility_bygubq.svg",
  },
  {
    title: "Loft",
    image:
      "https://res.cloudinary.com/duwmjod0j/image/upload/v1642170500/AquaHeat/Quote%20Icons/question%204/loft_a4lomo.svg",
  },
  {
    title: "Airing Cupboard",
    image:
      "https://res.cloudinary.com/duwmjod0j/image/upload/v1642170500/AquaHeat/Quote%20Icons/question%204/cupboard_yhdve5.svg",
  },
  {
    title: "Garage",
    image:
      "https://res.cloudinary.com/duwmjod0j/image/upload/v1642170500/AquaHeat/Quote%20Icons/question%204/garage_kdopbo.svg",
  },
  {
    title: "Other",
    image:
      "https://res.cloudinary.com/duwmjod0j/image/upload/v1642170500/AquaHeat/Quote%20Icons/question%204/other_prnpcc.svg",
  },
];
